module.exports = __webpack_public_path__ + "static/img/no_access_img_v2.5d1e1d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/no_access_img_v2.png
// module id = P2Yr
// module chunks = 134